<div class="title-bar no-container-margin">
  @for (breadCrumb of rootBreadCrumbs; track breadCrumb) {
    <span class="bread-crumb-root">{{breadCrumb | translate}}</span>
    <span class="bread-crumb-separator"> / </span>
  }
  <span class="bread-crumb-head">{{titleText | translate}}</span>
</div>
